const Graph = require('./BaseGraph')

module.exports = class WebinarGraph extends Graph 
{
    constructor(apiDomain, path="webinar")
    {
        super(apiDomain, path)
    }

    webinarRegister(fields, params=null)
    {
        if (params)
            return { type: 'createRegistrant', query: `mutation {
                createRegistrant(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'createRegistrant', query: `mutation createRegistrant (
            $webinar_event_id: Int!, 
            $first_name: String!,
            $last_name: String!, 
            $email: String!, 
            $phone: String!,
            $street: String!,
            $cityTown: String!,
            $stateProvince: String!,
            $zipPostal: String!,
            $country: String!,
            $registrant_from: String!
            ) {
            createRegistrant(webinar_event_id: $webinar_event_id,
                first_name: $first_name, 
                last_name: $last_name, 
                email: $email, 
                phone: $phone
            )
            ${this.queryFields(fields)}
        }` }
    }

    eventQuery(fields, params=null)
    {
        if (params)
            return { type: 'webinarEvent', query: this.queryString('webinarEvent', fields, params) }

        return { type: 'webinarEvent', query: `query getWebinarEvent ($eventId: Int, $isLatest: Int, $title: String, $eventType: Int, $zoom_id: String) {
            webinarEvents(eventId: $eventId, isLatest: $isLatest, title: $title, eventType: $eventType, zoom_id: $zoom_id)
            ${this.queryFields(fields)}
        }` }
    }

    eventsQuery(fields, params=null)
    {
        if (params)
            return { type: 'webinarEvents', query: this.queryString('webinarEvents', fields, params) }

        return { type: 'webinarEvents', query: `query getWebinarEvents ($search: String, $sort: String, $limit: Int, $offset: Int) {
            webinarEvents(search: $search, sort: $sort, limit: $limit, offset: $offset)
            ${this.queryFields(fields)}
        }` }
    }
    
}